import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {notifyError} from '../redux/notificationReducer';

class PermissionRoute extends Component {

	componentWillMount() {
		const {permission, session, notifyError} = this.props;
		let hasPermission = (session && session.permission_names && session.permission_names.includes(permission));
		!hasPermission && notifyError('You do not have permission to access this page');
	}

	render() {
		const {component: Component, permission, session, ...rest} = this.props;
		return (
			<Route
				{...rest}
				render={
					props => (
						(session && session.permission_names && session.permission_names.includes(permission))
							? <Component {...props}/>
							: <Redirect to={{
								pathname: '/dashboard',
								state: { from: props.location }
							}}/>
					)
				}
			/>
		)
	}
}

const mapStateToProps = state => ({
	session: state.session
});

const mapDispatchToProps = dispatch => bindActionCreators({
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PermissionRoute);
